export default {
  READ: "READ",
  DELETE: "DELETE"
};
